import { Plus } from '@orgus/ui/icons';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { DataGate, PageBody } from '../components/shell/PageBody.tsx';
import { PageActions } from '../components/shell/TopBar.tsx';
import { Button, Segmented, Tooltip } from '@orgus/ui';
import { useDateRange } from '../features/history/data.ts';
import { RangeControl } from '../features/history/RangeControl.tsx';
import { SessionHistory } from '../features/history/SessionHistory.tsx';
import '../features/new-session/command.ts';
import { NewSessionHost } from '../features/new-session/NewSessionHost.tsx';
import { openNewSession } from '../features/new-session/store.ts';
import { SessionDrawerHost } from '../features/sessions/SessionDrawer.tsx';
import { SessionsSkeleton, SessionsView } from '../features/sessions/SessionsView.tsx';

/** Every Claude Code session, grouped by project, with a live detail drawer (docs/design-system/pages/sessions.md). */
export default function Sessions() {
  const [order, setOrder] = useState<string[]>([]);
  const [params, setParams] = useSearchParams();
  const { range, setRange } = useDateRange();
  const view = params.get('view') === 'history' ? 'history' : 'live';
  const setView = (v: 'live' | 'history') =>
    setParams(
      (p) => {
        const n = new URLSearchParams(p);
        if (v === 'history') n.set('view', 'history');
        else n.delete('view');
        return n;
      },
      { replace: true },
    );
  return (
    <PageBody wide>
      {view === 'history' ? (
        <RangeControl
          className="mb-4"
          range={range}
          setRange={setRange}
          lead={
            <Segmented<'live' | 'history'>
              label="Sessions view"
              size="md"
              options={[
                { value: 'live', label: 'Live' },
                { value: 'history', label: 'History' },
              ]}
              value={view}
              onChange={setView}
            />
          }
        />
      ) : (
        <div className="mb-4">
          <Segmented<'live' | 'history'>
            label="Sessions view"
            size="md"
            options={[
              { value: 'live', label: 'Live' },
              { value: 'history', label: 'History' },
            ]}
            value={view}
            onChange={setView}
          />
        </div>
      )}
      <PageActions>
        <Tooltip content="Start Claude Code anywhere" shortcut={['n']}>
          <Button variant="secondary" size="sm" icon={<Plus className="text-accent-text" />} onClick={() => openNewSession()}>
            New session
          </Button>
        </Tooltip>
      </PageActions>
      <DataGate skeleton={<SessionsSkeleton />}>
        {view === 'history' ? <SessionHistory range={range} /> : <SessionsView onOrder={setOrder} />}
        <SessionDrawerHost order={view === 'history' ? [] : order} />
      </DataGate>
      <NewSessionHost />
    </PageBody>
  );
}
